import React from 'react';
import { Paper } from '@nextiva/next-ui-components';
import * as LaunchpadConstants from 'constants/launchpad';

const TEST_ID = `${LaunchpadConstants.TEST_ID}-Grid-Card`;

export const LaunchpadGridCard = ({ children }) => (
  <Paper
    sx={{
      boxShadow: '0px 0px 8px 0px rgba(34,38,72,0.16)',
    }}
    data-testid={TEST_ID}
  >
    {children}
  </Paper>
);
